import DeadlineAuditTechnicalPanel from './DeadlineAuditTechnicalPanel'
import DeadlineAssessmentCard from './DeadlineAssessmentCard'
import DeadlineAiValidationCard from './DeadlineAiValidationCard'
import DeadlineEvidenceCard from './DeadlineEvidenceCard'
import DeadlineFeedbackCorrectionCard from './DeadlineFeedbackCorrectionCard'
import DeadlineHumanReviewBanner from './DeadlineHumanReviewBanner'
import DeadlineInterpretedActionsCard from './DeadlineInterpretedActionsCard'
import DeadlineReasonsCard from './DeadlineReasonsCard'
import DeadlineResolvedDeadlinesCard from './DeadlineResolvedDeadlinesCard'
import DeadlineSummaryCard from './DeadlineSummaryCard'
import DeadlineTasksCard from './DeadlineTasksCard'
import DeadlineWarningsCard from './DeadlineWarningsCard'
import { getDeadlineResultPresentation } from '../deadlineResultPresentation'
import { isNationalCalendarFallbackEvidence } from '@components/shared/calendarFallback'

function getField(source, camelKey, pascalKey = camelKey.charAt(0).toUpperCase() + camelKey.slice(1), fallback = undefined) {
  return source?.[camelKey] ?? source?.[pascalKey] ?? fallback
}

function EmptyResult() {
  return (
    <section className="rules-card deadline-empty-result">
      <div className="rules-card-body">
        <i className="fas fa-scale-balanced" />
        <h3>Nenhuma simulação executada</h3>
        <p>Preencha os dados da comunicação processual e execute o motor para visualizar a análise.</p>
      </div>
    </section>
  )
}

export default function DeadlineSimulationResult({ result, originalPayload }) {
  if (!result) return <EmptyResult />

  const presentation = getDeadlineResultPresentation(result)
  const { humanReviewRequired, calculatedWithReview } = presentation
  const interpretedActions = getField(result, 'interpretedActions', 'InterpretedActions', [])
  const resolvedDeadlines = getField(result, 'resolvedDeadlines', 'ResolvedDeadlines', [])
  const generatedTasks = humanReviewRequired ? [] : getField(result, 'generatedTasks', 'GeneratedTasks', [])
  const explanations = getField(result, 'explanations', 'Explanations', [])
  const warnings = getField(result, 'warnings', 'Warnings', [])
  const evidence = getField(result, 'evidence', 'Evidence', [])
  const audit = getField(result, 'audit')

  return (
    <div className="deadline-simulation-result">
      <DeadlineAssessmentCard assessment={getField(result, 'deadlineAssessment')} calculatedWithReview={calculatedWithReview} />
      <DeadlineHumanReviewBanner result={result} reasons={explanations} shouldShow={humanReviewRequired} calculatedWithReview={calculatedWithReview} />
      <DeadlineSummaryCard result={result} presentation={presentation} />
      <DeadlineInterpretedActionsCard actions={interpretedActions} />
      <DeadlineResolvedDeadlinesCard deadlines={resolvedDeadlines} />
      <DeadlineTasksCard tasks={generatedTasks} deadlines={resolvedDeadlines} hasHumanReview={humanReviewRequired} />
      <DeadlineAiValidationCard result={result} />
      <DeadlineFeedbackCorrectionCard result={result} originalPayload={originalPayload} />
      <DeadlineReasonsCard reasons={explanations} />
      <DeadlineEvidenceCard evidence={evidence.filter((item) => !isNationalCalendarFallbackEvidence(item))} />
      <DeadlineWarningsCard warnings={warnings} />
      <DeadlineAuditTechnicalPanel audit={audit} rawResult={result} />
    </div>
  )
}
